import { useEffect, useMemo, useState } from 'react';
import GlobalTableGenerator from '../../../../components/GlobalTableGenerator';
import FilterSection from '../TopCardOverview/FilterSection';
import { typeOfStudent } from '../../../../utils/constants/GlobalStaticData';
import dayjs from 'dayjs';
import { Button, Paper, Stack } from '@mui/material';
import { useDispatch } from 'react-redux';
import { getRefundProjectTable } from '../../../../redux/features/refundSlice';
import { useSelector } from 'react-redux';
import { downloadCSV, makeCSV } from '../../../../components/CustomTableWithPagination/csvExport';

const TableJSON = [
  {
    field: 'project_name',
    headerName: 'Project',
    width: 180,
  },
  {
    field: 'total_refund_request_count',
    headerName: 'Total Refund Request Raised Count',
    width: 260,
    align: 'center',
    headerAlign: 'center',
  },
  {
    field: 'total_refund_request_amount',
    headerName: 'Total Refund Request Amount',
    width: 260,
    align: 'center',
    headerAlign: 'center',
  },
  {
    field: 'approved_count',
    headerName: 'Approved Count',
    width: 160,
    align: 'center',
    headerAlign: 'center',
  },
  {
    field: 'approved_amount',
    headerName: 'Approved Amount',
    width: 180,
    align: 'center',
    headerAlign: 'center',
  },
  {
    field: 'rejected_count',
    headerName: 'Rejected Count',
    width: 160,
    align: 'center',
    headerAlign: 'center',
  },
  {
    field: 'rejected_amount',
    headerName: 'Rejected Amount',
    width: 180,
    align: 'center',
    headerAlign: 'center',
  },
];

export default function RefundProjectTable() {
  const [showFilters, setShowFilters] = useState(true);
  const [selectedType, setSelectedType] = useState(typeOfStudent[0]);
  // const [projectId, setProjectId] = useState('');
  const [fromDate, setFromDate] = useState(dayjs().startOf('month').format('YYYY-MM-DD')); //DEFAULT SET TO CURRENT MONTH STARTING DATE TO ENDING DATE
  const [toDate, setToDate] = useState(dayjs().endOf('month').format('YYYY-MM-DD'));

  const dispatch = useDispatch();

  const { data, projectTableLoading } = useSelector((state) => state.refund.refundProjectTable);

  const permanentLastRow = useMemo(() => {
    const safeData = Array.isArray(data) ? data : [];

    return safeData.reduce(
      (acc, values) => ({
        total_refund_request_count: acc.total_refund_request_count + (Number(values?.total_refund_request_count) || 0),
        total_refund_request_amount:
          acc.total_refund_request_amount + (Number(values?.total_refund_request_amount) || 0),
        approved_count: acc.approved_count + (Number(values?.approved_count) || 0),
        approved_amount: acc.approved_amount + (Number(values?.approved_amount) || 0),
        rejected_count: acc.rejected_count + (Number(values?.rejected_count) || 0),
        rejected_amount: acc.rejected_amount + (Number(values?.rejected_amount) || 0),
      }),
      {
        total_refund_request_count: 0,
        total_refund_request_amount: 0,
        approved_count: 0,
        approved_amount: 0,
        rejected_count: 0,
        rejected_amount: 0,
      },
    );
  }, [data]);

  const dispatchParams = useMemo(() => {
    return {
      fromDate,
      toDate,
      type: selectedType?.id,
      // projectId,
    };
  }, [fromDate, toDate, selectedType]);

  useEffect(() => {
    dispatch(getRefundProjectTable(dispatchParams));
  }, []);

  const filterSubmit = () => {
    dispatch(getRefundProjectTable(dispatchParams));
  };

  const handleExport = () => {
    const exportRows = [
      ...(Array.isArray(data) ? data : []),
      {
        project_name: 'TOTAL',
        ...permanentLastRow,
      },
    ];

    const csv = makeCSV({
      headers: TableJSON,
      rows: exportRows,
    });

    downloadCSV(csv, `Refund_Project_Report_${dayjs().format('YYYY-MM-DD_HH-mm')}.csv`);
  };

  return (
    <Stack>
      <FilterSection
        showFilters={showFilters}
        setShowFilters={setShowFilters}
        selectedType={selectedType}
        setSelectedType={setSelectedType}
        // projectId={projectId}
        // setProjectId={setProjectId}
        fromDate={fromDate}
        setFromDate={setFromDate}
        toDate={toDate}
        setToDate={setToDate}
        filterSubmit={filterSubmit}
        loading={false}
      />

      <Stack direction="row" justifyContent="flex-end" sx={{ mb: 2 }}>
        <Button variant="contained" onClick={handleExport} disabled={projectTableLoading || !data?.length}>
          Export
        </Button>
      </Stack>
      <Paper mt={1} elevation={4}>
        <GlobalTableGenerator
          permenantLastRow={{
            ...permanentLastRow,
            project_id: '*',
            project_name: 'TOTAL',
          }}
          columns={TableJSON}
          rows={data}
          TableStyle={{
            minWidth: 1000,
            borderCollapse: 'collapse',
            '& .MuiTableCell-root': {
              border: '1px solid #d9d9d9',
            },
            '& tbody tr:last-child .MuiTableCell-root': {
              fontWeight: '800 !important',
            },
            ...(projectTableLoading
              ? []
              : {
                  '& tbody tr:last-child': {
                    bgcolor: '#f7d979ff',
                    fontWeight: '800 !important',
                  },
                }),
          }}
          TableHeadStyle={{
            bgcolor: '#3a79bb',
            '& .MuiTableCell-root': {
              color: '#fff',
              fontWeight: 600,
            },
          }}
          loading={projectTableLoading}
        />
      </Paper>
    </Stack>
  );
}
